import {useState, useEffect} from 'react'
import {useWindowSize} from '../use-window-size'
import {getResponsiveBreakpoint} from './../../helpers/responsive-helper'
import type {ResponsiveBreakpointKey} from './../../helpers/responsive-helper'

export function useResponsiveInfo(): ResponsiveBreakpointKey {
  const {width} = useWindowSize()
  const responsiveBreakpoint = getResponsiveBreakpoint(width)
  const [breakpoint, setBreakpoint] = useState<ResponsiveBreakpointKey>(responsiveBreakpoint)
  useEffect(() => setBreakpoint(responsiveBreakpoint), [responsiveBreakpoint])

  return breakpoint
}
